<template>
  <div class="row">
    <div class="col-lg">
      <tr>
        <td>
          <!-- if schedule type = cluster, display list of cluster-->
          <div class="col-md" id="type">
            <!-- select which cluster to schedule -->
            <base-input label="Cluster:">
              <el-select
                class="select-primary"
                placeholder="Choose..."
                size="large"
                v-model="selects.multi"
                @change="getWeekdaysData(selects.multi)"
              >
                <el-option
                  style="color: #000000"
                  v-for="option in selects.multicast"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </td>
      </tr>

      <!-- scheduler table -->
      <div class="col-lg-12 col-md" style="padding-top: 10px">
        <h3 class="card-title brightness">
          <div>
            <!-- <h2>Scheduler Table</h2> -->
            <!-- :cell-style="tableRowStyle" -->
            <el-table
              ref="table1"
              :data="weekdays"
              v-loading="loading"
              lazy
              :load="editweekdays"
              highlight-current-row
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column align="right" label="Action">
                <div slot-scope="props">
                  <!-- @click.native="modals.edit = true" -->
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click="getRows(props.$index, props.row)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                      :disabled="disableButton"
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                </div>
                <!-- modal for edit -->
                <modal
                  :show.sync="modals.edit"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div class="row justify-content-center mt-12">
                            <div class="col-sm-12">
                              <div>
                                <h3 style="color: #344675">
                                  Scheduler Information
                                </h3>
                                <base-input
                                  v-model="tempIndex"
                                  type="text"
                                  label="No: "
                                  disabled
                                ></base-input>
                                <base-input
                                  v-model="tempHour"
                                  type="text"
                                  label="Hour"
                                  disabled
                                ></base-input>
                                <base-input
                                  v-model="tempMin"
                                  type="text"
                                  label="Min"
                                  disabled
                                ></base-input>
                                <base-input label="On/Off">
                                  <el-select
                                    class="select-success"
                                    size="large"
                                    v-model="tempStatus"
                                    type="text"
                                  >
                                    <el-option
                                      v-for="option in selects.status"
                                      class="select-success"
                                      :value="option.value"
                                      :label="option.label"
                                      :key="option.label"
                                    >
                                    </el-option>
                                  </el-select>
                                </base-input>
                                <base-input label="Brightness">
                                  <el-select
                                    class="select-success"
                                    size="large"
                                    v-model="tempBrightness"
                                    type="text"
                                  >
                                    <el-option
                                      v-for="option in selects.br"
                                      class="select-success"
                                      :value="option.value"
                                      :label="option.label"
                                      :key="option.label"
                                    >
                                    </el-option>
                                  </el-select>
                                </base-input>
                              </div>
                            </div>
                            <div>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click.native="handleEdit()"
                                >Submit</base-button
                              >
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.edit = false"
                                >Cancel</base-button
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>
              </el-table-column>
            </el-table>
          </div>
        </h3>
      </div>

      <!-- submit scheduler -->
      <div id="button">
        <div id="button_container_1">
          <button
            :disabled="disableButton"
            type="success"
            class="btn btn-success"
            @click="submitWeekdays(selects.multi)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>

    <div class="col-lg">
      <!-- scheduler brightness graph -->
      <div class="chart-area">
        <line-chart
          :chart-data="lineChart.chartData"
          :gradient-colors="lineChart.gradientColors"
          :gradient-stops="lineChart.gradientStops"
          :extra-options="lineChart.extraOptions"
          :height="300"
        ></line-chart>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import { Modal, BasePagination } from "src/components";
import swal from "sweetalert2";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    Modal,
    BasePagination,
  },
  props: ["test"],
  data() {
    return {
      parentData: this.test,
      disableButton: true,
      tempIndex: "",
      tempHour: "",
      getRow: "",
      tempMin: "",
      tempStatus: "",
      tempBrightness: "",
      loading: false,
      weekdaysArray: [],
      getWeekdays: [],
      weekdays: [],
      hexData: [],
      base64Weekdays: [],
      sendWeekdays: [],
      selects: {
        holidayInMalaysia: [
          { value: "010120010120", label: "New Year's Day" },
          { value: "080220080220", label: "Thaipusam" },
          { value: "260120270120", label: "Chinese New Year" },
          { value: "010520010520", label: "Labour Day" },
          { value: "070520070520", label: "Wesak Day" },
          { value: "100520100520", label: "Nuzul Al-Quran" },
          { value: "240520260520", label: "Hari Raya Aidilfitri" },
          { value: "310720020820", label: "Hari Raya Haji" },
          { value: "310820310820", label: "Merdeka Day" },
          { value: "200820200820", label: "Awal Muharram" },
          { value: "060620060620", label: "Agong's Birthday" },
          { value: "160920160920", label: "Malaysia Day" },
          { value: "141120151120", label: "Deepavali" },
          { value: "291020291020", label: "Prophet Muhammad's Birthday" },
          { value: "251220251220", label: "Christmas Day" },
        ],
        multi: "",
        multicast: [],
        multicastid: [],
        device: "",
        devices: [],
        scheType: "multicast",
        // schedulerType: [
        //   { value: "multicast", label: "Cluster" }
        // ],
        hour: "",
        hours: [
          { value: 1, label: "1 a.m." },
          { value: 2, label: "2 a.m." },
          { value: 3, label: "3 a.m." },
          { value: 4, label: "4 a.m." },
          { value: 5, label: "5 a.m." },
          { value: 6, label: "6 a.m." },
          { value: 7, label: "7 a.m." },
          { value: 8, label: "8 a.m." },
          { value: 9, label: "9 a.m." },
          { value: 10, label: "10 a.m." },
          { value: 11, label: "11 a.m." },
          { value: 12, label: "12 p.m." },
          { value: 13, label: "1 p.m." },
          { value: 14, label: "2 p.m." },
          { value: 15, label: "3 p.m." },
          { value: 16, label: "4 p.m." },
          { value: 17, label: "5 p.m." },
          { value: 18, label: "6 p.m." },
          { value: 19, label: "7 p.m." },
          { value: 20, label: "8 p.m." },
          { value: 21, label: "9 p.m." },
          { value: 22, label: "10 p.m." },
          { value: 23, label: "11 p.m." },
          { value: 0, label: "12 a.m." },
        ],
        min: "",
        mins: [
          { value: "0", label: "00" },
          { value: 5, label: "05" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 25, label: "25" },
          { value: 30, label: "30" },
          { value: 35, label: "35" },
          { value: 40, label: "40" },
          { value: 45, label: "45" },
          { value: 50, label: "50" },
          { value: 55, label: "55" },
        ],
        status: [
          { value: "On", label: "On" },
          { value: "Off", label: "Off" },
        ],
        br: [
          { value: 10, label: "10" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 40, label: "40" },
          { value: 50, label: "50" },
          { value: 60, label: "60" },
          { value: 70, label: "70" },
          { value: 80, label: "80" },
          { value: 90, label: "90" },
          { value: 100, label: "100" },
        ],
        simple: "",
        brightness: "",
        id: 0,
      },
      lineChart: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Brightness",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        // loaded: false,
        // extraOptions: chartConfigs.aChartOptions,
        // gradientColors: [
        //   "rgba(82, 222, 151, 0.5)",
        //   "rgba(82, 222, 151, 0.3)",
        //   "rgba(82, 222, 120, 0.1)"
        // ],
        // gradientStops: [1, 0.4, 0]
      },
      modals: {
        addHolidays: false,
        add: false,
        holidays: false,
        edit: false,
        editweekend: false,
        editholiday: false,
      },
      tableColumns: [
        {
          prop: "index",
          label: "No:",
        },
        {
          prop: "hour",
          label: "Hour",
          // minWidth: 200
        },
        {
          prop: "min",
          label: "Min",
          // minWidth: 250
        },
        {
          prop: "onoff",
          label: "Status",
          // minWidth: 250
        },
        {
          prop: "brightness",
          label: "Brightness",
          // minWidth: 250
        },
      ],
    };
  },
  methods: {
    getlist() {
      let arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
         
          } else {
          
            let data = res.message.cluster_list;
         
            this.multicast = data;
          

            // if array empty, promp error and redirect to create cluster page
            if (this.multicast.length < 1) {
              swal({
                title: "Cluster empty",
                text: "Please create cluster to continue!",
                type: "warning",
                confirmButtonText: "OK",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              }).then(() => {
                this.$router.push("/admin/clustermanagement");
              });
            } else {
            
              this.selects.multicast = [];
              for (let i = 0; i < this.multicast.length; i++) {
                let multicast_array = {
                  value: this.multicast[i].clusterid,
                  label: this.multicast[i].clustername,
                  conntype: this.multicast[i].conntype,
                };
                let data = {
                  id: this.multicast[i].clusterid,
                  multiid: this.multicast[i].multicastid,
                  conntype: this.multicast[i].conntype,
                };
                this.selects.multicastid.push(data);
               
                this.selects.multicast.push(multicast_array);
              }
              // assign default value to table
              this.selects.multi = this.multicast[0].clusterid;
              this.getWeekdaysData(this.selects.multi);
            }
          }
        })
        .catch((err) => {
      
        });
    },
    getWeekdaysData(clusterID) {
      this.lineChart.loaded = false;
      // get table data for weekdays

      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster/" + clusterID)
        .then((res) => {
          if (res.error) {
           
          } else {
       

            let arr = res.message.schedule_info.weekdays;
            this.getWeekdays = res.message.schedule_info.weekdays;

            for (var i = 0; i < arr.length; i++) {
              // convert on / off to human readable format
              if (parseInt(arr[i].slice(10, 12), 16) === 0) {
                var onoff = "off";
              } else {
                var onoff = "on";
              }
              parseInt(arr[i].slice(10, 12), 16);
              // slice array to 7 portion and assign to variable
              var my_weekdays = {
                header: parseInt(arr[i].slice(0, 2), 16),
                profile: parseInt(arr[i].slice(2, 4), 16),
                index: parseInt(arr[i].slice(4, 6), 16),
                hour: parseInt(arr[i].slice(6, 8), 16),
                min: parseInt(arr[i].slice(8, 10), 16),
                onoff: onoff,
                brightness: parseInt(arr[i].slice(12, 14), 16) * 10,
              };

              this.weekdays.push(my_weekdays);
         
              this.charts.push(my_weekdays);
           
              this.schedulerBrightnessChart(this.charts);
            }
          }
        })
        .catch((err) => {
        
        });
      // clear array
      this.weekdays = [];
      this.charts = [];
    },
    initLine(time, brightness) {
   
      let chartData = {
        datasets: [
          {
            label: "Brightness",
            fill: true,
            borderColor: "rgba(82, 222, 151, 1)",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "rgba(82, 222, 151, 1)",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#be55ed",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [50, 50, 80, 80, 90, 90, 50, 50, 50, 60, 60, 60, 70],
          },
        ],
        labels: time,
      };
      this.lineChart.chartData = chartData;
      this.lineChart.loaded = true;
    },

    schedulerBrightnessChart(data) {
     
      let timeScheduler = [];
      let brightnessScheduler = [];
      // combine hour and min
      for (var i = 0; i < data.length; i++) {
        let time = data[i].hour + ":" + data[i].min;
      
        timeScheduler.push(time);
        let brightness = data[i].brightness;
      
        brightnessScheduler.push(brightness);
      }
      this.initLine(timeScheduler, brightnessScheduler);
      timeScheduler = [];
      brightnessScheduler = [];
    },

    handleEdit() {
      swal({
        title: "Are you sure?",
        text: `You want to edit status: ${this.tempStatus} & brightness: ${this.tempBrightness}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editweekdays();
          swal({
            title: "Edited!",
            text: `You edited status: ${this.tempStatus} & brightness: ${this.tempBrightness}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
          this.loading = false;
        }
      });
    },
    editweekdays() {
   
      let newWeekdays = {
        header: 5,
        profile: 1,
        index: this.tempIndex,
        hour: this.tempHour,
        min: this.tempMin,
        onoff: this.tempStatus,
        brightness: this.tempBrightness,
      };
   
      this.weekdays[this.tempIndex] = newWeekdays;
      this.weekdays.splice(this.weekdays.length, this.weekdays.length);
    
      this.modals.edit = false;
      this.disableButton = false;
    
    },
    submitWeekdays(clusterID) {
      let a, b, multi, contype;
    
      for (var i = 0; i < this.selects.multicastid.length; i++) {
    
        if (this.selects.multicastid[i].id == clusterID) {
      
          multi = this.selects.multicastid[i].multiid;
          contype = this.selects.multicastid[i].conntype;
        }
      }
      for (var i = 0; i < this.weekdays.length; i++) {
       

        // convert header to hex
        let hexHeader = "0" + (this.weekdays[i].header & 0xff).toString(16);
       

        // convert profile to hex
        let hexProfile = "0" + (this.weekdays[i].profile & 0xff).toString(16);
       
        //convert index to hex
        let hexIndex = "0" + (this.weekdays[i].index & 0xff).toString(16);
     

        // convert hour to hex
        let hexHour = ("0" + (this.weekdays[i].hour & 0xff).toString(16)).slice(
          -2
        );
       

        // convert min to hex
        let hexMin = ("0" + (this.weekdays[i].min & 0xff).toString(16)).slice(
          -2
        );
     

        // convert on off to hex
        if (this.weekdays[i].onoff === "On") {
          var hexOnOff = "0" + 1;
       
        } else {
          var hexOnOff = "0" + 0;
       
        }
        var hexBrightness =
          "0" + (this.weekdays[i].brightness / 10).toString(16);
        // convert brightness to hex

        // arrange all hex value in one var
        var hexValue =
          hexHeader +
          hexProfile +
          hexIndex +
          hexHour +
          hexMin +
          hexOnOff +
          hexBrightness;
    

        // push all hex value in one array
        this.hexData.push(hexValue);
     
      }

      // compare 2 array and push change attributes in new array (untuk hantar yang berubah sahaja)
      for (var i = 0; i < this.weekdays.length; i++) {
        if (this.hexData[i] !== this.getWeekdays[i]) {
          this.sendWeekdays.push(this.hexData[i]);
      
        }
      }

      // convert data in sendWeekdays to base64
      var test = [];
      for (var i = 0; i < this.sendWeekdays.length; i++) {
        var base64Value = btoa(
          String.fromCharCode.apply(
            null,
            this.sendWeekdays[i]
              .replace(/\r|\n/g, "")
              .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
              .replace(/ +$/, "")
              .split(" ")
          )
        );
       
        this.base64Weekdays.push(base64Value);
     

        //constuct data
        let queue = {
          data: base64Value,
        };

        test.push(queue);
      }

     

      var urlAPI = ":8003/api/v1/control/light/multicast/" + multi;

      let data = {
        conntype: contype,
        context: "RAW",
        command: test, //array of schedule
      };

    
      this.$http
        .post(urlAPI, data)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
          
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
            });
          }
        })
        .catch((err) => {
       
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        });

      

      // //hantar haziq (REMAIN SAME)
      var urlAPI2 = ":8004/api/v1/session/cluster/" + clusterID;

      let payload2 = {
        type: "WEEKDAYS",
        data: this.hexData,
      };

    

      this.$http
        .put(urlAPI2, payload2)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
          
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
            });
          }
        })
        .catch((err) => {
       
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        });

     

      this.sendWeekdays = [];
      this.hexData = [];
      hexValue = null;
    
      // update chart data
      this.getWeekdaysData(this.selects.multi);
    },
    tableRowStyle({ row, rowIndex }) {
      return "background-color: transparent";
    },
    getRows(Index, row) {
      (this.tempIndex = `${row.index}`),
        (this.tempHour = `${row.hour}`),
        (this.tempMin = `${row.min}`),
        (this.tempStatus = `${row.onoff}`),
        (this.tempBrightness = `${row.brightness}`);

      this.modals.edit = true;
    },
  },
  mounted() {
    let roleSession = JSON.parse(sessionStorage.getItem("accessList"));

  
    for (var i = 0; i < roleSession.length; i++) {
   
      if (roleSession[i] === "cluster.update") {
      
        this.disableButton = true;
        // this.disabledButton = true;
      }
      if (roleSession[i] === "admin.view") {
        this.disableButton = false;
      }
      if (roleSession[i] === "cluster.update") {
        this.disableButton = false;
      }
    }
    this.getlist();
   
    //   this.getWeekdaysData(this.test.multicast[0].multicastid);
  },
  computed: {},
};
</script>
